<script>
  import Chart from 'chart.js';
  import { Bar, mixins } from 'vue-chartjs';

  export default {
    name: "score-chart",
    extends: Bar,
    mixins: [mixins.reactiveProp],
    data() {
      return {
        colors: ["rgb(35,35,35)", "rgb(234,157,45)", "rgb(69,108,150)", "rgb(215,62,159)", "rgb(234,26,41)", "rgb(34,26,217)", "rgb(100,214,69)", "rgb(21,60,13)", "rgb(30,163,239)"],
        options: {
          responsive: true,
          maintainAspectRatio: false,
          //title: {
          //  display: false,
          //  text: "Scores"
          //},
          scales: {
            xAxes: [{
              ticks: {
                min: 0
              }
            }],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  suggestedMin: 0,
                  suggestedMax: 5,
                  min: 0,
                  max: 5
                },
                display: true,
                scaleLabel: {
                  display: true,
                  labelString: "Score"
                }
              }
            ]
          }
        }
      }
    },
    methods: {
      ApplyDefaultColors(datasets) {
        //Override coloring with the defaults
        for (var i = 0; i < datasets.length; i++) {
          datasets[i].backgroundColor = this.colors[i];
          datasets[i].borderColor = this.colors[i];
        }
        return datasets;
      },
      Render() {
        var self = this;
        this.addPlugin({
          beforeDraw(chart, options) {
          },
          beforeUpdate(chart, options) {
            chart.data.datasets = self.ApplyDefaultColors(chart.data.datasets);
          }
        });

        this.renderChart(this.chartData, this.options);
        this.$emit("Render", this);
      },
    },
    created() {

    },
    mounted() {
      this.Render();
      this.$emit("Loaded", this);
    }
  }

</script>
